export interface AuthenticatedUserPayload {
  user_id: string
  email: string
  display_name: string
  domain: string
  role: 'owner' | 'editor' | 'viewer' | string
  workspace_id: string
  provider: string
}

export interface AuthSessionPayload {
  authRequired: boolean
  authenticated: boolean
  denied: boolean
  reason: string | null
  user: AuthenticatedUserPayload | null
  workspaceId: string
  provider?: 'cloudflare_access' | 'trusted_headers' | 'disabled' | string
  cloudflareAccessConfigured?: boolean
  allowedDomains: string[]
}

export const fetchAuthSession = async (): Promise<AuthSessionPayload> => {
  const response = await fetch('/api/auth/session', {
    headers: { Accept: 'application/json' },
    credentials: 'include',
  })
  if (!response.ok) {
    throw new Error(`Auth session request failed: HTTP ${response.status}`)
  }
  return response.json() as Promise<AuthSessionPayload>
}
